import { FaqService } from 'src/app/services/faq.service';
// import { AddFaqComponent } from './../FAQs/add-faq/add-faq.component';
import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
// import { AddFaqComponent } from '../FAQs/add-faq/add-faq.component';

@Injectable({
  providedIn: 'root'
})
export class Popup3Guard implements CanDeactivate<unknown> {

constructor(private service:FaqService){

}

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // return true;
    console.log(nextState.url)
    console.log("inside guard")
    let item=JSON.parse(localStorage.getItem('isFaqSaved'))
    let questionCheck=JSON.parse(localStorage.getItem('questionEntered'))
    console.log(item)
    console.log(questionCheck)
    if(!item&&questionCheck){
      this.service.triggerPopup(true)
      localStorage.setItem("faqRedirectRoute",(nextState.url))
      console.log("openpopup")

      return false
    }
    return true
  }

}
